module.exports = __webpack_public_path__ + "static/img/img_2.ef216d8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enterprise/images/img_2.webp
// module id = 2Hzk
// module chunks = 4